module.exports = __webpack_public_path__ + "img/op_five_steps_2.5525d93e.png";